<template>
  <helper-layout :loaded="mx_loaded">
    <v-card class="details-wrap">
      <v-layout>
        <v-flex>
          <!-- 入金日期 -->
          <div class="detailWrap">
            <label class="width-90">{{ $t("Views.Finance.rujin_date") }}</label><label>：</label>
            <span>{{ formatDate(paymentDetails.tradeDate) }}</span>
          </div>
          <!-- 入金方式 -->
          <div class="detailWrap">
            <label class="width-90">{{ $t("Views.Finance.rujin_method") }}</label><label>：</label>
            <span>{{ paymentDetails.paymentMethodName }}</span>
          </div>
          <!-- 入金担当 -->
          <div class="detailWrap">
            <label class="width-90">{{ $t("Views.Finance.rujin_operator") }}</label><label>：</label>
            <span>{{ paymentDetails.operatorName }}</span>
          </div>
          <!-- 未分配金额 -->
          <div class="detailWrap">
            <label class="width-90">{{ $t("Views.Order.unallocatedSmount") }}</label><label>：</label>
            <span>{{ $util.data.moneyFmt(paymentDetails.dispatchBalance, paymentDetails.paymentCurrencyName) }}</span>
          </div>
        </v-flex>
        <v-flex>
          <!-- 客户信息 -->
          <div class="detailWrap">
            <label class="width-90">{{ $t("Views.Finance.rujin_client_info") }}</label><label>：</label>
            <span>
              {{ paymentDetails.customerName }}
              {{ formatSerialNum(paymentDetails.customerNumber) }}
              {{ formatSerialNum(paymentDetails.newCustomerNumber) }}
            </span>
          </div>
          <!-- 入金币种 -->
          <div class="detailWrap">
            <label class="width-90">{{ $t("Views.Finance.rujin_currency") }}</label><label>：</label>
            <span>{{ currencyEnum[paymentDetails.paymentCurrencyName] }}</span>
          </div>
          <!-- 结算方式 -->
          <div class="detailWrap">
            <label class="width-90">{{ $t("Views.Finance.rujin_settle_method") }}</label><label>：</label>
            <span>{{ paymentDetails.settlements && getEnumVals(paymentDetails.settlements, 'settlementType') }}</span>
          </div>
        </v-flex>
        <v-flex>
          <!-- 所属销售 -->
          <div class="detailWrap">
            <label class="width-62">{{ $t("Views.Finance.sales") }}</label><label>：</label>
            <span>{{ paymentDetails.customerSales }}</span>
          </div>
          <!-- 入金金额 -->
          <div class="detailWrap">
            <label class="width-62">{{ $t("Views.Finance.rujin_amount") }}</label><label>：</label>
            <span>{{ $util.data.moneyFmt(paymentDetails.amount, paymentDetails.paymentCurrencyName) }}</span>
          </div>
          <!-- 结算货币 -->
          <div class="detailWrap">
            <label class="width-62">{{ $t("Views.Finance.rujin_settle_currency") }}</label><label>：</label>
            <span>{{ getEnumVals(paymentDetails.settlementCurrencyNames, 'currencyName') }}</span>
          </div>
        </v-flex>
      </v-layout>
    </v-card>

    <v-card class="details-wrap margin-top-20">
      <!-- 现结或月结显示的标题 -->
      <template
        v-if="
          paymentDetails.paymentNowOrders &&
            paymentDetails.paymentNowOrders.length == 0 &&
            paymentDetails.paymentMonthOrders &&
            paymentDetails.paymentMonthOrders.length == 0&&
            paymentDetails.recharge && paymentDetails.recharge.length==0
        "
      >
        <div
          class="detail-title"
          :style="`color:${getPrimary(color)}`"
        >
          {{ $t("Views.Finance.viewPayList") }}
        </div>
        <v-layout class="text-align-center table-border">
          <v-flex>
            {{ $t("Views.Goods.noData") }}
          </v-flex>
        </v-layout>
      </template>
      <div>
        <!-- 详情模式 - 后台合并 现结和月结 字段 -->
        <template v-if="pageState === 'detail'">
          <div
            v-for="(item, index) in paymentDetails.orders"
            :key="`order_${index}`"
            class="table-border margin-top-20"
          >
            <v-layout class="no-mar">
              <v-flex>
                <div class="detailWrap">
                  <label>{{ $t("Views.Finance.orderNumbers") }}</label><label>：</label>
                  <span>{{ item.number }}</span>
                </div>
              </v-flex>
              <v-flex>
                <div class="detailWrap">
                  <label>{{ $t("Views.Order.orderAmount") }}</label><label>：</label>
                  <span>{{ item.targetCurrencyOrderPrice | moneyFmt(paymentDetails.paymentCurrencyName) }}</span>
                </div>
              </v-flex>
              <v-flex>
                <div class="detailWrap">
                  <label>{{ $t("Views.Order.taxAmount") }}</label><label>：</label>
                  <span>{{ item.targetCurrencyTaxRateAmount | moneyFmt(paymentDetails.paymentCurrencyName) }}</span>
                </div>
              </v-flex>
              <v-flex>
                <div class="detailWrap">
                  <label>{{ $t("Views.Order.otherAmount") }}</label><label>：</label>
                  <span :class="item.targetCurrencyOtherPrice<0?'oRed':''">
                    {{ item.targetCurrencyOtherPrice | moneyFmt(paymentDetails.paymentCurrencyName) }}
                  </span>
                  （{{ $t("Views.Order.otherTax") }}：
                  <span :class="item.targetCurrencyOtherPrice<0?'oRed':''">
                    {{ item.targetCurrencyOtherTaxRateAmount | moneyFmt(paymentDetails.paymentCurrencyName) }}
                  </span>）
                </div>
              </v-flex>
              <v-flex>
                <div class="detailWrap">
                  <label>{{ $t("Views.Finance.orderPrice") }}</label><label>：</label>
                  <span>{{ item.targetCurrencyPrice | moneyFmt(paymentDetails.paymentCurrencyName) }}</span>
                </div>
              </v-flex>
            </v-layout>
            <!-- 商品信息 -->
            <material-table
              v-if="item.items.length > 0"
              :has-paginate="false"
              :headers="noPendingConfirmproductHeaders"
              :items="item.items"
            />
            <!-- 其他科目明细 -->
            <material-table
              v-if="item.otherDetails.length > 0"
              :has-paginate="false"
              :headers="otherDetailsHeader"
              :items="item.otherDetails"
              :has-total="true"
              class="product-detail-table"
            />
            <!-- 订单支付信息 -->
            <detailsTable
              ref="monthTable"
              :items="item.payments"
              :curreny-name="paymentDetails.paymentCurrencyName"
              :rules="[ v => v <= item.unpaiedAmount || $t('Views.Finance.inputTips')]"
              ipt-key="amount"
              :staff-list="staffList"
              :ipt-map="item.payments"
              @gettableData="getData"
            />
          </div>
        </template>
        <template v-else>
          <!-- 现结内容 -->
          <div
            v-for="(item, index) in paymentDetails.paymentNowOrders"
            :key="`now_${index}`"
            class="table-border margin-top-20"
          >
            <v-layout>
              <v-flex>
                <div class="detailWrap">
                  <label>{{ $t("Views.Finance.orderNumbers") }}</label><label>：</label>
                  <span>{{ item.number }}</span>
                </div>
              </v-flex>
              <v-flex>
                <div class="detailWrap">
                  <label>{{ $t("Views.Order.orderAmount") }}：</label>
                  <span>{{ item.targetCurrencyOrderPrice | moneyFmt(paymentDetails.paymentCurrencyName) }}</span>
                </div>
              </v-flex>
              <v-flex>
                <div class="detailWrap">
                  <label>{{ $t("Views.Order.taxAmount") }}：</label>
                  <span>{{ item.targetCurrencyTaxRateAmount | moneyFmt(paymentDetails.paymentCurrencyName) }}</span>
                </div>
              </v-flex>
              <v-flex>
                <div class="detailWrap">
                  <label>{{ $t("Views.Order.otherAmount") }}：</label>
                  <span :class="item.targetCurrencyOtherPrice<0?'oRed':''">
                    {{ item.targetCurrencyOtherPrice | moneyFmt(paymentDetails.paymentCurrencyName) }}
                  </span>
                  （{{ $t("Views.Order.otherTax") }}：
                  <span :class="item.targetCurrencyOtherPrice<0?'oRed':''">
                    {{ item.targetCurrencyOtherTaxRateAmount | moneyFmt(paymentDetails.paymentCurrencyName) }}
                  </span>）
                </div>
              </v-flex>
              <v-flex>
                <div class="detailWrap">
                  <label>{{ $t("Views.Finance.orderPrice") }}：</label>
                  <span>{{ item.targetCurrencyPrice | moneyFmt(paymentDetails.paymentCurrencyName) }}</span>
                </div>
              </v-flex>
            </v-layout>
            <!-- 商品信息 -->
            <material-table
              v-if="item.items.length > 0"
              :has-paginate="false"
              :headers="noPendingConfirmproductHeaders"
              :items="item.items"
            />
            <!-- 其他科目明细 -->
            <material-table
              v-if="item.otherDetails.length > 0"
              :has-paginate="false"
              :headers="otherDetailsHeader"
              :items="item.otherDetails"
              :has-total="true"
              class="product-detail-table"
            />
            <!-- 订单支付信息 -->
            <detailsTable
              ref="nowTable"
              :items="item.payments"
              :rules="[ v => v <= item.unpaiedAmount || $t('Views.Finance.inputTips')]"
              :curreny-name="paymentDetails.paymentCurrencyName"
              ipt-key="amount"
              :staff-list="staffList"
              :ipt-map="`paymentDetails.paymentNowOrders.${index}.payments`"
              @gettableData="getData"
            />
          </div>
          <!-- 月结内容 -->
          <div
            v-for="(item, index) in paymentDetails.paymentMonthOrders"
            :key="`month_${index}`"
            class="table-border margin-top-20"
          >
            <v-layout class="no-mar">
              <v-flex>
                <div class="detailWrap">
                  <label>{{ $t("Views.Finance.orderNumbers") }}</label><label>：</label>
                  <span>{{ item.number }}</span>
                </div>
              </v-flex>
              <v-flex>
                <div class="detailWrap">
                  <label>{{ $t("Views.Order.orderAmount") }}</label><label>：</label>
                  <span>{{ item.targetCurrencyOrderPrice | moneyFmt(paymentDetails.paymentCurrencyName) }}</span>
                </div>
              </v-flex>
              <v-flex>
                <div class="detailWrap">
                  <label>{{ $t("Views.Order.taxAmount") }}</label><label>：</label>
                  <span>{{ item.targetCurrencyTaxRateAmount | moneyFmt(paymentDetails.paymentCurrencyName) }}</span>
                </div>
              </v-flex>
              <v-flex>
                <div class="detailWrap">
                  <label>{{ $t("Views.Order.otherAmount") }}</label><label>：</label>
                  <span :class="item.targetCurrencyOtherPrice<0?'oRed':''">
                    {{ item.targetCurrencyOtherPrice | moneyFmt(paymentDetails.paymentCurrencyName) }}
                  </span>
                  （{{ $t("Views.Order.otherTax") }}：
                  <span :class="item.targetCurrencyOtherPrice<0?'oRed':''">
                    {{ item.targetCurrencyOtherTaxRateAmount | moneyFmt(paymentDetails.paymentCurrencyName) }}
                  </span>）
                </div>
              </v-flex>
              <v-flex>
                <div class="detailWrap">
                  <label>{{ $t("Views.Finance.orderPrice") }}</label><label>：</label>
                  <span>{{ item.targetCurrencyPrice | moneyFmt(paymentDetails.paymentCurrencyName) }}</span>
                </div>
              </v-flex>
            </v-layout>
            <!-- 商品信息 -->
            <material-table
              v-if="item.items.length > 0"
              :has-paginate="false"
              :headers="noPendingConfirmproductHeaders"
              :items="item.items"
            />
            <!-- 其他科目明细 -->
            <material-table
              v-if="item.otherDetails.length > 0"
              :has-paginate="false"
              :headers="otherDetailsHeader"
              :items="item.otherDetails"
              :has-total="true"
              class="product-detail-table"
            />
            <!-- 订单支付信息 -->
            <detailsTable
              ref="monthTable"
              :items="item.payments"
              :curreny-name="paymentDetails.paymentCurrencyName"
              :rules="[ v => v <= item.unpaiedAmount || $t('Views.Finance.inputTips')]"
              ipt-key="amount"
              :staff-list="staffList"
              :ipt-map="`paymentDetails.paymentMonthOrders.${index}.payments`"
              @gettableData="getData"
            />
          </div>
        </template>
        <!-- 预付款才显示的标题 -->
        <div
          v-if="paymentDetails.recharge && paymentDetails.recharge.length > 0"
          class="detail-title  margin-top-20"
          :style="`color:${getPrimary(color)}`"
        >
          {{ $t("Views.Finance.prePay") }}
        </div>
        <!-- 预付款 -->
        <div
          v-if="paymentDetails.recharge && paymentDetails.recharge.length > 0"
          class="table-border "
        >
          <v-layout row>
            <v-flex>
              <div class="detailWrap">
                <label>{{ $t("Views.Finance.acountType") }}：</label>
                <span>{{ paymentDetails.accountName }}</span>
              </div>
            </v-flex>
            <v-flex>
              <div class="detailWrap">
                <label>{{ $t("Views.Customer.balance") }}：</label>
                <span>{{ paymentDetails.balance | moneyFmt(paymentDetails.paymentCurrencyName) }}</span>
              </div>
            </v-flex>
            <v-flex />
          </v-layout>
          <detailsTable
            ref="preTable"
            class=" margin-top-20"
            :items="paymentDetails.recharge"
            :curreny-name="paymentDetails.paymentCurrencyName"
            :show-sales="false"
            ipt-key="amount"
            ipt-map="paymentDetails.recharge"
            :staff-list="staffList"
            :rules="getsettlement(paymentDetails.settlements)?[]:[ v => v > 0 || $t('Views.Customer.numBiggerThan0')]"
            @gettableData="getData"
          />
        </div>
      </div>
    </v-card>
    <!-- 底部按钮 -->
    <v-layout>
      <v-flex xs12 text-xs-center class="bottom-btn">
        <v-btn color="cancel" outline @click="() => $router.go(-1)">
          {{ $t("Views.Goods.goBack") }}
        </v-btn>
        <v-btn
          v-if="pageState !== 'detail'"
          v-clickthrottle="{ handle: confirmDialog, delay: 4000 }"
          :color="color"
        >
          {{ $t("Views.Finance.confirm") }}
        </v-btn>
      </v-flex>
    </v-layout>
    <!-- 确认弹窗 -->
    <material-dialog
      :width="400"
      :visible="confirmVisible"
      :title="$t('Views.Setting.pleaseConfirm')"
      @cancleFn="confirmVisible = false"
      @confirmFn="confirm"
    >
      <template><span class="desc">
        {{ $t('Views.Finance.rujin_sure_dispatch') }}</span>
      </template>
    </material-dialog>
  </helper-layout>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins'
import ENUMS from '@/dict/enums'
import { format } from 'date-fns'
import detailsTable from '../../Finance/detailsTable'
export default {
  components: {
    detailsTable
  },
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      detailsId: '',
      pageState: '',
      paymentDetails: {
        recharge: [],
        paymentNowPayments: [],
        paymentMonthPayments: []
      },
      otherDetailsHeader: [
        {
          text: $t('Views.Order.otherDetails'),
          value: 'itemName'
        },
        {
          text: $t('Views.Order.quantity'),
          value: 'quantity',
          align: 'right'
        },
        {
          text: $t('Views.Order.unitPrice'),
          render: (h, param) => {
            return h('div', `${this.$util.data.moneyFmt(param.row.price)}`)
          },
          align: 'right'
        },
        {
          text: $t('Views.Order.priceOfDollar'),
          render: (h, param) => {
            return h('div', { class: param.row.targetPrice < 0 ? 'oRed' : '' }, `
            ${this.$util.data.moneyFmt(param.row.targetPrice, this.paymentDetails.paymentCurrencyName)}`)
          }
        },
        {
          text: $t('Views.Order.subtotalOfDollar'),
          value: 'targetTotalPrice',
          render: (h, param) => {
            return h('div', { class: param.row.targetTotalPrice < 0 ? 'oRed' : '' },
              `${this.$util.data.moneyFmt(param.row.targetTotalPrice, this.paymentDetails.paymentCurrencyName)}`)
          }
        },
        {
          text: $t('Views.Order.subtotal'),
          value: 'totalPrice',
          render: (h, param) => {
            return h('div', `${this.$util.data.moneyFmt(param.row.totalPrice)}`)
          }
        }
      ],
      noPendingConfirmproductHeaders: [// 商品信息的header
        {
          text: $t('Views.Order.index'),
          align: 'center',
          render: (h, param) => {
            return h('div', `${param.index + 1}  `)
          },
          width: 50
        },
        {
          text: $t('Views.Order.product_name_label'),
          render: (h, param) => {
            return h('material-img', {
              props: {
                desc: param.row.product.name,
                pictureKey: param.row.pictureKey,
                pictureWidth: 40,
                pictureHeight: 40,
                preview: true,
                capacity: param.row.product.capacity,
                serialNumber: param.row.product.serialNumber,
                descW: 300
              }
            })
          }
        },
        {
          text: $t('Views.Order.capcity'),
          value: 'product.capacity',
          type: 'nest'
        },
        {
          text: $t('Views.Order.quantity'),
          align: 'right',
          render: (h, param) => {
            return h('div', `${param.row.quantity} `)
          }
        },
        {
          text: $t('Views.Order.unitPrice'),
          render: (h, param) => {
            return h('div', `${this.$util.data.moneyFmt(param.row.price)}`)
          },
          align: 'right'
        },
        {
          text: $t('Views.Order.rateOfYen2Dollar'),
          value: 'exchangeRate',
          isCurrency: true
        },
        {
          text: $t('Views.Order.priceOfDollar'),
          value: 'targetPrice',
          render: (h, param) => {
            return h('div', `${this.currencyMap[this.paymentDetails.paymentCurrencyName]}${this.formatPrice(param.row.targetPrice)}  `)
          }
        },
        {
          text: $t('Views.Order.subtotalOfDollar'),
          value: 'targetTotalPrice',
          render: (h, param) => {
            return h('div', `${this.currencyMap[this.paymentDetails.paymentCurrencyName]}${this.formatPrice(param.row.targetTotalPrice)}  `)
          }
        },
        {
          text: $t('Views.Order.subtotal'),
          value: 'totalPrice',
          render: (h, param) => {
            return h('div', `${this.$util.data.moneyFmt(param.row.totalPrice)}  `)
          }
        }
      ],
      payNowValid: true,
      payMonthValid: true,
      currencyMap: {
        JPY: '¥',
        USD: '$'
      },
      confirmVisible: false,
      staffList: []
    }
  },
  computed: {
    color() {
      return this.$store.state.app.color
    },
    ...mapState('finance', ['stateMentList']),
    ...mapState('setting', ['staffAllData']),
    currencyEnum() {
      return ENUMS.currencyName
    }
  },
  created() {
    this.detailsId = this.$route.query.id
    this.pageState = this.$route.query.state
    this.getStaffAllData({ isActive: true, permissionCheck: true }).then(() => {
      this.staffList = this.staffAllData.items
    })
    this.getDetails()
  },
  methods: {
    ...mapActions('finance', [
      'getAccountDetails',
      'paymentConfirm',
      'getStatementList',
      'manageStatement',
      'getRemittanceDetail'
    ]),
    ...mapActions('setting', ['getStaffAllData']),
    confirm() {
      const paymentNowPayments = []
      const paymentMonthPayments = []
      this.paymentDetails.paymentNowOrders && this.paymentDetails.paymentNowOrders.map(item => {
        item.payments.map(child => {
          if (!child.id) {
            child.amount = Number(child.amount)
            paymentNowPayments.push(child)
          }
        })
      })
      this.paymentDetails.paymentMonthOrders && this.paymentDetails.paymentMonthOrders.map(item => {
        item.payments.map(child => {
          if (!child.id) {
            paymentMonthPayments.push(child)
          }
        })
      })
      const formData = Object.assign({}, {
        id: this.$route.query.id,
        recharge: this.paymentDetails.recharge.length > 0 ? this.paymentDetails.recharge[this.paymentDetails.recharge.length - 1] : null,
        paymentNowPayments: paymentNowPayments,
        paymentMonthPayments: paymentMonthPayments
      })
      this.paymentConfirm(formData).then((data) => {
        this.$store.commit('app/setNotification', {
          msg: this.$t('Views.Statement.processed'),
          type: 'success'
        })
        this.$router.go(-1)
        this.mx_loaded_fn() // 页面加载完成
      })
    },
    sumArr(itemName, targetArr, arrName2) {
      let sum = 0
      const _arr = []
      targetArr.forEach((item) => {
        if (arrName2) {
          arrName2 && item[arrName2].forEach(child => {
            _arr.push(child[itemName])
          })
        } else {
          _arr.push(item[itemName])
        }
      })
      _arr.forEach((val) => {
        sum += Number(val)
      })
      return sum
    },
    getDetails() {
      if (!this.mx_loaded) this.mx_loading_fn()

      const action = this.pageState === 'detail' ? 'getRemittanceDetail' : 'getAccountDetails'
      this[action]({ id: this.detailsId }).then((data) => {
        this.paymentDetails = data
        this.paymentDetails.recharge = this.paymentDetails.recharge
        if (this.paymentDetails.paymentCurrencyName === 'JPY') {
          this.otherDetailsHeader.splice(3, 2)
          this.noPendingConfirmproductHeaders.splice(5, 3)
        } else {
          this.otherDetailsHeader.splice(this.otherDetailsHeader.length - 1, 1)
          this.noPendingConfirmproductHeaders.splice(this.noPendingConfirmproductHeaders.length - 1, 1)
        }
        this.mx_loaded_fn()
      })
    },
    // 显示不同界面 优先级：现结 -月结 - 预付款
    getStatus() {
      let show = true
      this.paymentDetails.settlements && this.paymentDetails.settlements.forEach(item => {
        if (item.settlement && item.settlement.settlementType === 'PaymentNow' || item.settlement && item.settlement.settlementType === 'PaymentMonthly') {
          if (this.paymentDetails && this.paymentDetails.paymentMonthOrders.length === 0 && this.paymentDetails && this.paymentDetails.paymentNowOrders.length === 0) {
            show = true
          } else {
            show = false
          }
        } else {
          show = true
        }
      })
      return show
    },
    getsettlement(data) {
      return data && data.some(item => item === 'PaymentNow' || item === 'paymentMonthly')
    },
    getEnumVals(data, enumkey) {
      const arr = []
      data && data.forEach(item => {
        arr.push(ENUMS[enumkey][item])
      })
      return arr.join('，')
    },
    formatDate(date) {
      return format(date, 'YYYY-MM-DD')
    },
    getPrimary(color) {
      return ENUMS.primaryColor[color]
    },
    getData(value, key, form) {
      this.$nextTick(() => {
        if (form.indexOf('.') > -1) {
          const keyArr = form.split('.')
          let target = this
          keyArr.forEach(k => {
            if (target[k]) {
              target = target[k]
            }
          })
          target[key] = value
        } else {
          this[form][key] = value
        }
      })
    },
    formatPrice(num) {
      if (num === undefined) return
      num = parseInt((num * 100).toFixed(10)) / 100
      return this.$util.data.toThousands(num)
    },
    confirmDialog() {
      this.confirmVisible = true
    },
    formatSerialNum(str) {
      return this.$util.data.addBrackets(str)
    }
  }
}
</script>

<style lang="scss" scoped>
.width-90{
  width:90px;
}
.width-115{
  width:115px;
}
.width-62{
  width:62px;
}
.table-border {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 20px;
}
</style>
